import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ProductHeaderCardWidgetComponent } from '../product-header-card-widget/product-header-card-widget.component';

@Component({
  selector: 'app-formly-product-header-card-widget',
  templateUrl: './formly-product-header-card-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ProductHeaderCardWidgetComponent
  ]
})
export class FormlyProductHeaderCardWidgetComponent extends FieldType {

  onDelete = output<boolean>();

  constructor(
  ) {
    super();
    // This is to solve the issue DEV-1018 error: insert or update on table "product" violates foreign key constraint "FK_91a19e6613534949a4ce6e76ff8"
    // It might be correctly fixed in updateEntityAssets and updateEntityAsset -> Backend!!! Since Minor Prior task, no time to spent.
    this.onDelete.subscribe((res) => {
      if (res) {
        this.model.featuredAsset = null;
        this.model.featuredAssetId = null;
      }
    });
  }
}